// @flow
export default (theme: Object) => ({
    form: {
        padding: theme.spacing(3, 0, 5, 0),
    },
    label: {
        fontWeight: 600,
    },
    tileRoot: {
        '&[type="checkbox"]': {
            marginRight: 'unset',
            border: 'unset',
        },

        '&.active $tile': {
            background: theme.palette.primary.light,

            '& $tileIcon': {
                color: theme.palette.common.white,
            },
            '& $tileCaption': {
                color: theme.palette.common.white,
            },
        },
    },
    tile: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        boxShadow: theme.shadows[2],
        padding: theme.spacing(1),
        borderRadius: 2,

        '&::before, &::after': {
            content: '""',
        },
    },
    tileIcon: {
        color: theme.palette.grey[500],
        width: '40%',
        height: '40%',
    },
    tileCaption: {
        color: theme.palette.grey[500],
        textAlign: 'center',
    },
});
